import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import TechBackground from "@/components/TechBackground";

// Lazy load below-the-fold components
const ServicesSection = lazy(() => import("@/components/ServicesSection").then(m => ({ default: m.ServicesSection })));
const AboutSection = lazy(() => import("@/components/AboutSection").then(m => ({ default: m.AboutSection })));
const CTASection = lazy(() => import("@/components/CTASection").then(m => ({ default: m.CTASection })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));


const Index = () => {
  const location = useLocation();
  const canonical = `https://iloader.de${location.pathname === "/datenschutz" ? "/datenschutz" : "/"}`;
  return (
    <div className="min-h-screen bg-background text-foreground relative">
      <Helmet>
        <link rel="canonical" href={canonical} />
      </Helmet>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-4 focus:left-4 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg">
        Zum Inhalt springen
      </a>
      <TechBackground />
      <Navigation />
      <main id="main-content">
        <HeroSection />
        <Suspense fallback={<div className="min-h-[50vh]" />}>
          <ServicesSection />
          <AboutSection />
          <CTASection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
